module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-03 3.77827d25.png";